import { render, staticRenderFns } from "./IBS-results.vue?vue&type=template&id=8439f9c0"
import script from "./IBS-results.vue?vue&type=script&lang=js"
export * from "./IBS-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports